<template>
  <label
    class="radio-wrap"
    tabindex="0"
    @keyup.enter="onChange"
  >
    <input
      tabindex="-1"
      type="radio"
      :name="name"
      :value="value"
      :checked="isChecked"
      @change="onChange"
    >
    <span tabindex="-1">{{ label }}</span>
  </label>
</template>

<script>
  export default {
    name: "RadioBase",
    props: {
      label: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      isChecked: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    methods: {
      onChange (value) {
        this.$emit('change', value)
      }
    }
  }
</script>
